import { shadowRoot } from '@iheartjane/reefer';
import { inIframe } from '@iheartjane/utils';
import { useCallback } from 'react';

import { postMessageToIframeParent } from '@jane/shared/util';

export const useScrollToNode = () => {
  const isInIframe = inIframe();
  const headerOffset = 80;

  return useCallback(
    (element: HTMLElement | null | undefined) => {
      const elementY = element?.getBoundingClientRect().top;
      const elementMarginString = element
        ? window.getComputedStyle(element).marginTop
        : '0';
      const elementMargin = parseInt(elementMarginString, 10);

      if (!elementY) return;

      if (isInIframe) {
        const payload = elementY - headerOffset - elementMargin;
        postMessageToIframeParent({
          messageType: 'scrollTo',
          payload: payload,
        });
      } else {
        const scrollTop = document.documentElement.scrollTop;

        window.scrollTo({
          top: elementY - headerOffset - elementMargin + scrollTop,
          behavior: 'smooth',
        });
      }
    },
    [isInIframe]
  );
};

export const useScrollToElement = (elementId: string) => {
  const scrollToNode = useScrollToNode();

  return useCallback(() => {
    const element = (shadowRoot() || document).getElementById(elementId);

    scrollToNode(element);
  }, [elementId, scrollToNode]);
};
